import { State, Action, StateContext, Store, Selector } from '@ngxs/store';
import { UsageAlertRule } from '@app/models/usage-alert-rules/usage-alert-rules.model';
import { DNASchedule } from '@app/models/dna-schedule/dna-schedule.model';

const category = 'Settings';

export class SetUsageAlerts {
    static readonly type = `[${category}] UsageAlerts`;
    constructor(public alerts: UsageAlertRule[]) {}
}

export class SetDNASchedules {
    static readonly type = `[${category}] SetDNASchedules`;
    constructor(public schedules: DNASchedule[]) {}
}

interface ISettingsState {
    usageAlerts: UsageAlertRule[];
    schedules: DNASchedule[];
}

@State<ISettingsState>({
    name: 'settings',
    defaults: {
        usageAlerts: [],
        schedules: [],
    },
})
export class SettingsState {
    constructor(private store: Store) {}

    // available spans state
    @Selector([SettingsState])
    static usageAlerts(state: ISettingsState) {
        return state.usageAlerts;
    }

    @Action(SetUsageAlerts)
    setUsageAlerts(ctx: StateContext<ISettingsState>, action: SetUsageAlerts) {
        ctx.patchState({
            usageAlerts: action.alerts,
        });
    }

    // selected spans state
    @Selector([SettingsState])
    static schedules(state: ISettingsState) {
        return state.schedules;
    }

    @Action(SetDNASchedules)
    setDNASchedules(ctx: StateContext<ISettingsState>, action: SetDNASchedules) {
        ctx.patchState({
            schedules: action.schedules,
        });
    }

    getUsageAlerts() {
        return this.store.selectSnapshot(SettingsState.usageAlerts);
    }

    getDNASchedules() {
        return this.store.selectSnapshot(SettingsState.schedules);
    }
}
